<template>
  <div v-if="isNicknamePop" class="nickname-pop" @click.stop>
    <section class="pop-content">
      <div>
        <h3 class="pop-title">请填写用户昵称</h3>

        <div class="pop-form">
          <el-input size="small" v-model="nickname" style="margin-right:10px;width: 200px;" />
          <el-button
            type="primary"
            size="small"
            :loading="isLoading"
            :disabled="!nickname.trim()"
            @click="onApply"
          >
            确定
          </el-button>
        </div>

        <div class="pop-tips">
          <p>被邀请用户首次登录需填写用户昵称</p>
          <p>请填写真实姓名或其他可以被管理员识别的昵称</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Helper } from '@/lib/helper';
import Api from '@/apis/userCenter/index';

export default {
  name: 'NicknamePop',
  data() {
    return {
      nickname: '',
      isNicknamePop: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
    }),
    avatar() {
      return this.profile.avatar || this.defaultAvatar;
    },
  },
  mounted() {
    if (this.profile.role > 100 && !this.profile.nickname.trim()) {
      this.isNicknamePop = true;
    }
  },
  methods: {
    async onApply() {
      const strLen = Helper.getStrLen(this.nickname.trim());
      if (strLen > 10) {
        this.$message.error('昵称不允许超过10个中文字符');
        return;
      }

      this.reqModifyNickname();
    },
    reqModifyNickname() {
      if (this.isLoading) return;
      this.isLoading = true;

      const reqData = {
        nickname: this.nickname.trim(),
      };
      Api.modifyNickname(reqData)
        .then((res) => {
          if (Number(res?.head?.code) !== 0) return;

          this.$store.dispatch('userCenter/fetchCpProfile');
          this.isNicknamePop = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>


<style lang="less" scoped>
@popH: 300px;

.nickname-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);

  .pop-content {
    position: relative;
    width: 500px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .pop-title {
    font-size: 18px;
  }

  .pop-form {
    margin-top: 10px;
  }

  .pop-tips {
    margin-top: 20px;
    font-size: 14px;
    color: #999999;
  }
}
</style>
